export default "__VITE_ASSET__05IuDVoL__"